// Tolerates pasted "+1 (555) 123-4567"-style input.
export const normalizePhoneDigits = (raw: string): string => {
  let digits = raw.replace(/\D/g, '')
  if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1)
  return digits.slice(0, 10)
}

export const formatPhoneDisplay = (digits: string): string => {
  if (digits.length <= 3) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
